import React from 'react';

interface Props {
  children: React.ReactNode;
}

const EmptyLayout = ({ children }: Props) => {
  return <>{children}</>;
};

export default EmptyLayout;
